import { Pipe, PipeTransform } from '@angular/core';

import { Option } from '@mom/ui';

import { QuestionOption } from '../models/question/question-option.model';

@Pipe({
  name: 'toUiOption'
})
export class TransformToUiOptionPipe implements PipeTransform {
  transform(options: QuestionOption[]): Option<string>[] {
    if (!options) {
      return [];
    }
    return options.map((option) => ({
      value: option.id,
      text: option.optionTextLocales[0].name,
      subtext: option.optionTextLocales[0].subtext,
      description: option.optionTextLocales[0].description,
      exclusive: option.exclusive
    }));
  }
}
